import { createContext, useContext } from "react";

export type ComplianceRulesContextData = {
  usesDocs: boolean;
  usesProfiles: boolean;
  showCaseDetails: boolean;
  showEscalationDetails?: boolean;
  showPaymentDetails: boolean;
  showIncomingPaymentDetails: boolean;
  usesRuleHits: boolean;
  usesFundsComparison: boolean;
  caseResolutionType: string;
  defaultTabRoute: string;
  readonly: boolean;
  caseActionOptions: string[];
  showEscalationsTab: boolean;
};

export const getDefaultComplianceRulesContextData = (): ComplianceRulesContextData => {
  return {
    usesDocs: true,
    usesProfiles: true,
    showCaseDetails: false,
    showEscalationDetails: false,
    showPaymentDetails: false,
    showIncomingPaymentDetails: false,
    usesRuleHits: false,
    usesFundsComparison: false,
    caseResolutionType: "",
    defaultTabRoute: "profiles",
    readonly: false,
    caseActionOptions: [],
    showEscalationsTab: false,
  };
};

export const ComplianceRulesContext = createContext<ComplianceRulesContextData>(
  getDefaultComplianceRulesContextData(),
);

export const useAppContext = () =>
  useContext<ComplianceRulesContextData>(ComplianceRulesContext);
